import type { IAgoraRTCRemoteUser } from 'agora-rtc-sdk-ng'

import type { LoginRes } from '@/api/login'
import type Rtc from '@/utils/rtc'

export const LOBBY_CHANNEL = '8888'
export const STORAGE_KEY = 'chat_tutor_context'

export const TUTOR_METHOD = {
  INVITE: 'ArtTutorCallInvite',
  ACCEPT: 'ArtTutorCallAccept',
  REJECT: 'ArtTutorCallReject',
  END: 'ArtTutorCallEnd',
  CANCEL: 'ArtTutorCallCancel',
  LOBBY_STATE: 'ArtTutorCallLobbyState'
} as const

export type TutorRole = 'teacher' | 'student'

export type StoredContext = { userId: string; role: TutorRole }

export type InvitePayload = {
  studentId: string
  teacherId: string
  studentName: string
  rtcChannel: string
  studentRtmId: string
}

/** 业务用户 ID 字符串（雪花等大整数须后端 JSON 用引号返回 string） */
export function bizUserId(u: Pick<LoginRes['data'], 'id'> | null | undefined): string {
  if (!u) return ''
  return typeof u.id === 'string' ? u.id : String(u.id)
}

export function idEq(a: unknown, b: string): boolean {
  const sa = a == null ? '' : typeof a === 'string' ? a : String(a)
  return sa === b
}

export function loadStoredRole(userIdKey: string): TutorRole | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const s = JSON.parse(raw) as StoredContext
    if (String(s.userId) !== userIdKey || (s.role !== 'teacher' && s.role !== 'student')) return null
    return s.role
  } catch {
    return null
  }
}

export function persistRole(userIdKey: string, role: TutorRole) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ userId: userIdKey, role }))
}

export function rtmUidForRole(role: TutorRole, userIdKey: string) {
  return `${role === 'teacher' ? '10' : '20'}${userIdKey}`
}

export function callChannel(studentId: string, teacherId: string) {
  return `20${studentId}10${teacherId}`
}

export function parseTeacherFromMember(rtmId: string): string | null {
  if (!rtmId.startsWith('10')) return null
  const raw = rtmId.slice(2).trim()
  return raw.length > 0 ? raw : null
}

export function pickRemoteVideoUser(rtc: Rtc): IAgoraRTCRemoteUser | null {
  const main = rtc.client?.mainClient
  const users = main?.remoteUsers
  if (!users?.length) return null
  const withVideo = users.find((u) => u.hasVideo)
  if (withVideo) return withVideo
  if (users.length === 1) return users[0]
  return null
}
